import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const KEY = "bni-active-event-slug";
const DEFAULT_SLUG = "davangere-members-day-2026";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Localstorage-backed active event slug so admins can juggle multiple events without a re-deploy.
 * If no explicit choice has been made, defaults to the currently-live event.
 */
export function useEventSlug() {
  const [slug, setSlugState] = useState(() => localStorage.getItem(KEY) || DEFAULT_SLUG);
  const setSlug = useCallback((next) => {
    if (next) { localStorage.setItem(KEY, next); setSlugState(next); }
  }, []);
  return { slug, setSlug };
}

/** Admin-only: list all events for the picker. */
export function useEventList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const t = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (!t) { setLoading(false); return; }
    axios.get(`${API}/admin/events`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);
  return { items, loading };
}
